import React from "react";
import { InputTextarea } from "primereact/inputtextarea";

interface InputTextareaProps {
  keyName?: string;
  name: string;
  value?: string;
  label: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  inputClassName?: string;
  maxLength?: number;
}

export const FloatingLabelTextarea = React.forwardRef((props: InputTextareaProps, ref: React.Ref<any>) => {
  return (
    <span className="p-float-label w-100">
      <InputTextarea
        ref={ref}
        key={props.keyName}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        className={props.inputClassName || "w-100"}
        maxLength={props.maxLength}
      />
      <label htmlFor="inputtextarea">{props.label}</label>
    </span>
  );
});
